import { CommunitySelectorAutocomplete } from "@components/common/community-selector-autocomplete";
import { useIntl } from "react-intl";
import * as yup from "yup";
import messages from "./messages.i18n";
import { MagicButtonVendorSelector } from "@components/admin/admin-actions/admin-actions-forms/add-magic-button/magic-button-vendor-selector";
export const AddMagicButtonFormInitialValues = {
    community: undefined,
    websiteUrl: "",
    scriptName: "",
};
export const AddMagicButtonFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object().shape({
        community: yup.object().required(intl.formatMessage(messages.magicButtonCommunityRequired)),
        websiteUrl: yup
            .string()
            .required(intl.formatMessage(messages.magicButtonWebsiteUrlRequired))
            .url(intl.formatMessage(messages.magicButtonWebsiteUrlFormat)),
        scriptName: yup
            .string()
            .required(intl.formatMessage(messages.magicButtonScriptNameRequired))
            .matches(/^[a-zA-Z][a-zA-Z0-9_]*$/, { message: intl.formatMessage(messages.magicButtonScriptNameRegex) }),
    });
};
export const AddMagicButtonFormFields = () => {
    const intl = useIntl();
    return {
        templateDetails: [
            {
                id: "vendor",
                label: intl.formatMessage(messages.template),
                placeholder: intl.formatMessage(messages.template),
                required: true,
                component: MagicButtonVendorSelector,
                columns: 12,
            },
        ],
        nameDetails: [
            {
                id: "scriptName",
                label: intl.formatMessage(messages.scriptName),
                placeholder: intl.formatMessage(messages.scriptName),
                required: true,
                columns: 12,
            },
        ],
        websiteDetails: [
            {
                id: "websiteUrl",
                label: intl.formatMessage(messages.websiteUrl),
                placeholder: intl.formatMessage(messages.websiteUrl),
                required: true,
                columns: 12,
            },
        ],
        communityDetails: [
            {
                id: "community",
                label: intl.formatMessage(messages.community),
                placeholder: intl.formatMessage(messages.community),
                required: true,
                columns: 12,
                component: CommunitySelectorAutocomplete,
            },
        ],
    };
};
